export const ButtonSubmit = ({ data }) => (
	<button class="button button_theme_secondary button_width_200" type="submit" { ...data }>
		Подтвердить
	</button>
)

ButtonSubmit.name = 'ButtonSubmit';
